import { useEffect } from 'react';
import styled from 'styled-components/macro';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { State } from '../../../reducer';
import { namespace } from '../';
import { namespace as reportNamespace } from '../../reportTransaction';
import { useActions } from '../../../Actions';
import { useAccountId } from '../../../auth/useAccountId';
import useEffectCallback from '../../../util/useEffectCallback';
import { distances } from '../../../styles/constants';

import Page, { Back, Title } from '../../../components/Page';
import Details from './Details';
import NotFound from './NotFound';
import EventDetailsModal from './EventDetailsModal';
import { LoadingOverlay } from '../../../components/Loading';

import { CaptureTransaction } from '../../captureTransaction';
import { RefundTransaction } from '../../refundTransaction';
import { VoidTransaction } from '../../voidTransaction';
import { ExtendTransaction } from '../../extendTransaction';


const TransactionPage = () => {
    const accountId = useAccountId();
    const transactionId = useParams<{transactionId: string}>().transactionId;
    const { t } = useTranslation();
    const { fetchTransaction, openHistoryDetailsModal, closeHistoryDetailsModal, setView } = useActions(namespace);
    const { generateReport } = useActions(reportNamespace);
    const { transaction, session, isLoading, isNotFound, details, requestLogs, view } = useSelector<State, State[typeof namespace]>(
        (s) => s[namespace]
    );

    useEffectCallback(fetchTransaction, [accountId, transactionId]);

    // reset view to details on unmount
    useEffect(() => {
        return () => {
            setView('details');
        };
    }, [setView]);


    if (view ==='capture') {
        return <CaptureTransaction />;
    }
    if (view ==='refund') {
        return <RefundTransaction />;
    }
    if (view ==='void') {
        return <VoidTransaction />;
    }
    if (view === 'extend') {
        return <ExtendTransaction />;
    }

    return (
        <>
            <Page
                title={
                    <>
                        <Back />
                        <Title>{t('payments.transaction.title')}</Title>
                    </>
                }
                hasEnvFrame={true}
            >
                <Wrapper>
                    {transaction && (
                        <Details
                            transaction={transaction}
                            session={session}
                            requestLogs={requestLogs}
                            reportTransaction={generateReport}
                            openEventHistoryDetailsModal={openHistoryDetailsModal}
                        />
                    )}
                    {isNotFound && <NotFound transactionId={transactionId} />}
                    {isLoading && <LoadingOverlay />}
                </Wrapper>
            </Page>
            {details && <EventDetailsModal details={details} closeModal={closeHistoryDetailsModal} />}
        </>
    );
};

const Wrapper = styled.div`
    position: relative;
    min-height: calc(${distances.ginormous} + ${distances.large});
`;

export default TransactionPage;
